<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>机器人跑马灯</span>
        </div>

        <el-table :data="formData" border stripe>
          <el-table-column prop="type" label="类型">
            <template slot-scope="scope">
              <el-select v-model="scope.row.type" placeholder="请选择">
                <el-option
                  v-for="item in selectType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="is_enable" label="状态">
            <template slot-scope="scope">
              <el-select v-model.number="scope.row.is_enable" placeholder="请选择">
                <el-option
                  v-for="item in statusType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column width="500px" prop="time" label="时间范围">
            <template slot-scope="scope">
              <el-date-picker v-model="scope.row.time.start" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 40%" />
              -
              <el-date-picker v-model="scope.row.time.end" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 40%" />
            </template>
          </el-table-column>
          <el-table-column prop="rand" label="推送间隔(开始为0,读取第二个值">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.rand.start" style="width: 30%" />
              -
              <el-input v-model.number="scope.row.rand.end" style="width: 30%" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200px">
            <template slot-scope="scope">
              <el-button v-permisaction="['config:sendNotice:del']" type="danger" @click="del(scope.row.id, scope.$index)">删除</el-button>
              <el-button v-if="scope.row.id > 0" v-permisaction="['config:sendNotice:test']" :loading="loading" type="primary" @click="test(scope.row.type)">测速发送</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 10px;text-align: center">
          <el-button v-permisaction="['config:sendNotice:add']" type="primary" @click="add()">+</el-button>
          <el-button v-permisaction="['config:sendNotice:add']" type="primary" @click="onSubmit()">保存</el-button>
        </div>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { delCfg, getCfg, getSendNoticeType, testSendNotice, updateCfg } from '@/api/config/send-notice'

export default {
  name: 'SendNotice',
  data() {
    return {
      loading: false,
      name: 'sendNotice',
      drawer: [{ visible: false }],
      selectType: [],
      statusType: [
        { label: '启用', value: 1 },
        { label: '禁用', value: 0 }
      ],
      formData: [{
        type: '',
        is_enable: 0,
        time: {
          start: '',
          end: ''
        },
        rand: {
          start: '',
          end: ''
        }
      }]
    }
  },
  created() {
    this.getType()
    this.getTables()
  },
  methods: {
    test(typ) {
      this.loading = true
      testSendNotice({ type: typ }).then(res => {
        if (res.code === 200) {
          this.loading = false
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getType() {
      this.selectType = []
      getSendNoticeType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.selectType.push({ label: res.data[i], value: i, disabled: false })
          }
        }
      })
    },
    handleClose(done, index) {
      this.dialogVisible[index].visible = false
    },
    onSubmit() {
      for (const i in this.formData) {
        const _data = this.formData[i]
        if (_data.step <= 0) {
          this.msgError('步骤不能小于等于0')
          return
        }

        if (!_data.time.start || !_data.time.end) {
          this.msgError('时间范围有误')
          return
        }

        if (_data.time.start > _data.time.end) {
          this.msgError('开始时间不能大于结束时间')
          return
        }
        if (!_data.rand.start && !_data.rand.end) {
          this.msgError('推送间隔值有误')
          return
        }
        if (_data.rand.start > _data.rand.end) {
          this.msgError('推送间隔开始值不能大于结束值')
          return
        }
      }

      const data = JSON.stringify(this.formData)
      console.log('data', data)
      updateCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    listenSelectType() {
      for (const k in this.selectType) {
        const event = this.selectType[k]
        this.selectType[k].disabled = false
        for (const i in this.formData) {
          const val = this.formData[i]
          if (val.type === event.value) {
            this.selectType[k].disabled = true
          }
        }
      }
    },
    getTables() {
      getCfg().then(res => {
        this.formData = res.data.list
      })
    },
    add() {
      this.listenSelectType()
      let selectType = ''
      for (const i in this.selectType) {
        const val = this.selectType[i]
        if (!val.disabled) {
          selectType = val.value
          break
        }
      }

      if (!selectType) {
        this.msgError('无可选类型')
        return
      }
      this.formData.push({
        type: selectType,
        is_enable: 0,
        time: {
          start: '',
          end: ''
        },
        rand: {
          start: '',
          end: ''
        }
      })
    },
    del(id, index) {
      if (id > 0) {
        this.$confirm('是否确认删除数据项?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delCfg({ 'id': id }).then(res => {
            this.getTables()
          })
        })
      } else {
        this.formData = this.formData.filter((item, key) => {
          return index !== key
        })
      }
    }
  }
}
</script>

<style scoped>
</style>
